// products.js
export default {
	individual: [
		{
			id: 1,
			name: 'Motor Private',
			description:
				'Covers vehicles that are used for private/domestic purposes while motor commercial covers vehicles used for business/commercial purposes.',
			image: 'https://api.prod.nexus.ke/static/0c511db3-35e2-4744-b02b-4bbf326b37c5.jpeg',
			categoryColor: 'blue',
			category: 'Vehicle Insurance',
			classCode: '07',
			available: true,
			routeName: 'motor-private',
		},

		{
			id: 5,
			name: 'Fire Domestic',
			description:
				'Covers your house and belongings against risks including fire, theft, extreme weather, and other damages. Can also extend to cover domestic workers and liabilities.',
			image: 'https://api.prod.nexus.ke/static/84ace5fd-c641-4770-8b10-a9c9f6702d08.jpeg',
			categoryColor: 'orange',
			category: 'Property Insurance',
			classCode: '05',
			available: true,
			routeName: 'fire-domestic',
		},
		{
			id: 7,
			name: 'Medical',
			description:
				'Covers medical expenses of the insured and their dependents. The common covers comprise out-patient and in-patient covers with dental and optical extensions.',
			image: 'https://api.prod.nexus.ke/static/07dc2710-b76c-41b7-9e97-ebecf5840cca.jpeg',
			categoryColor: 'pink',
			category: 'Health Insurance',
			classCode: '07',
			available: false,
			comingSoon: true,
			routeName: 'medical',
		},
		{
			id: 9,
			name: 'Life Assurance',
			description:
				'A life insurance policy guarantees the insurer pays a sum of money to one or more named beneficiaries when the insured person dies in exchange for premiums paid by the policyholder during their lifetime.',
			image: 'https://api.prod.nexus.ke/static/e3e047c2-0762-4f87-b647-71228f50897b.jpeg',
			categoryColor: 'purple',
			category: 'Life Insurance',
			classCode: 'L1',
			available: false,
			comingSoon: true,
			routeName: 'life-assurance',
		},
		{
			id: 10,
			name: 'Annuities',
			description:
				'An annuity is a contract between you and an insurance company that requires the insurer to make payments to you, either immediately or in the future. You buy an annuity by making either a single payment or a series of payments.',
			image: 'https://api.prod.nexus.ke/static/dbbba784-7291-4161-98e1-cca46d547a95.jpeg',
			categoryColor: 'emerald',
			category: 'Retirement Planning',
			classCode: 'L2',
			available: false,
			comingSoon: true,
			routeName: 'annuities',
		},
		{
			id: 12,
			name: 'Unit Link and Linked Investments',
			description:
				'Products give policyholders both insurance and investment under a single integrated plan. The main objective is to facilitate the growth of capital invested by the client/policyholder.',
			image: 'https://api.prod.nexus.ke/static/60b22437-a65b-4f42-bf48-25230c809fd8.jpeg',
			categoryColor: 'red',
			category: 'Investment Products',
			classCode: 'L4',
			available: false,
			comingSoon: true,
			routeName: 'unit-link-and-linked-investments',
		},
		{
			id: 13,
			name: 'Non-Linked Investments',
			description:
				'Products give policyholders both insurance and investment under a single integrated plan. The main objective is to facilitate the growth of capital invested by the client/policyholder.',
			image: 'https://api.prod.nexus.ke/static/fed22584-0bac-4c03-b974-9f78894cb9df.jpeg',
			categoryColor: 'blue',
			category: 'Investment Products',
			classCode: 'L5',
			available: false,
			comingSoon: true,
			routeName: 'non-linked-investments',
		},
		{
			id: 15,
			name: 'Permanent Health',
			description:
				'Type of insurance typically obtained by an employer to offer benefits to employees who are unable to work due to long-term illness or disability. The benefit usually consists of payments made by the insurer, through the employer, to the employee.',
			image: 'https://api.prod.nexus.ke/static/796dfb7d-dff0-4fd2-a98c-6e31d155c4d6.jpeg',
			categoryColor: 'green',
			category: 'Health Insurance',
			classCode: 'L8',
			available: false,
			comingSoon: true,
			useIcon: false,
			routeName: 'permanent-health',
		},
		{
			id: 16,
			name: 'Home Insurance',
			description:
				'Covers your Home, Household items and Home+Household items.',
			image: 'https://api.prod.nexus.ke/static/ad2918f7-7aa1-40ed-b5e8-2d0702e31aa6.jpeg',
			categoryColor: 'blue',
			category: 'Home Insurance',
			classCode: 'L10',
			available: false,
			comingSoon: true,
			useIcon: false,
			routeName: 'home-insurance',
		},
	],
	business: [
		{
			id: 2,
			name: 'Motor Commercial',
			description:
				'Covers vehicles used for business or commercial activities, including taxis, trucks, and company cars.',
			image: 'https://api.prod.nexus.ke/static/10b37d9e-2dee-4114-bb60-2074a8f0e686.jpeg',
			categoryColor: 'green',
			category: 'Commercial Insurance',
			classCode: '02',
			available: true,
			routeName: 'motor-commercial',
		},
		{
			id: 4,
			name: 'Aviation Insurance',
			description:
				'Provides coverage for aircraft operations, pilots, and liabilities related to aviation risks. Ensures financial protection against damages and liabilities.',
			image: 'https://api.prod.nexus.ke/static/37145a05-784b-4b32-b395-a1723390340d.jpeg',
			categoryColor: 'sky',
			category: 'Aviation Insurance',
			classCode: '04',
			available: true,
			routeName: 'aviation-insurance',
		},
		{
			id: 8,
			name: 'Engineering Insurance',
			description:
				"Offers protection against a variety of risks associated with erection, testing, and working machinery, plants, or equipment. Includes coverage for contractors' risks, machinery breakdown, electronic equipment, and more.",
			image: 'https://api.prod.nexus.ke/static/59b77dc2-dc81-460b-9ef6-3ec448f4e01e.jpeg',
			categoryColor: 'purple',
			category: 'Industrial Insurance',
			classCode: '08',
			available: false,
			comingSoon: true,
			routeName: 'engineering-insurance',
		},
		{
			id: 3,
			name: 'Theft Insurance',
			description:
				'Covers loss or damage due to theft, burglary, or attempted theft. Protects your assets from unauthorized access and criminal activities.',
			image: 'https://api.prod.nexus.ke/static/5cd34519-5e33-4893-a524-b0bfc0bafb53.jpeg',
			categoryColor: 'red',
			category: 'Security Insurance',
			classCode: '03',
			available: true,
			routeName: 'theft-insurance',
		},
		{
			id: 11,
			name: 'Group Life',
			description:
				'This covers group life insurance by employers, loan protection schemes by financial institutions, and last expense schemes, either standalone or as riders to group life plans.',
			image: 'https://api.prod.nexus.ke/static/dcacbc7e-fcd9-4f33-abd9-0b4f6fc5bf0c.jpeg',
			categoryColor: 'pink',
			category: 'Employee Benefits',
			classCode: 'L3',
			available: false,
			comingSoon: true,
			routeName: 'group-life',
		},
		{
			id: 14,
			name: 'Group Credit',
			description:
				"Group credit life protection shields financiers, like banks and microfinance institutions, from financial loss if borrowers are unable to repay due to disability or death. It also prevents the borrower's family from inheriting unexpected debt during a time of grief.",
			image: 'https://api.prod.nexus.ke/static/60c47f1b-eae9-4389-96c9-aa75b4a515fa.jpeg',
			categoryColor: 'yellow',
			category: 'Credit Protection',
			classCode: 'L6',
			available: false,
			comingSoon: true,
			useIcon: false,
			routeName: 'group-credit',
		},
		{
			id: 16,
			name: 'Deposit Administration',
			description:
				'Is a pension plan administered by a life insurance company where pension funds accumulate in a master group annuity policy until a participant retires.',
			image: 'https://api.prod.nexus.ke/static/fb60d0db-b3f0-45db-9e50-c2f6cadb21e8.jpeg',
			categoryColor: 'sky',
			category: 'Pension Planning',
			classCode: 'L7',
			available: false,
			comingSoon: true,
			useIcon: false,
			routeName: 'deposit-administration',
		},
		{
			id: 6,
			name: 'Marine',
			description:
				'Covers the loss or damage of ships, cargo, terminals, and any transport by which the property is transferred, acquired, or held between the points of origin and the final destination.',
			image: 'https://api.prod.nexus.ke/static/acd52b04-baf4-4f39-a2c2-71803bf7bd77.jpeg',
			categoryColor: 'teal',
			category: 'Marine Insurance',
			classCode: '06',
			available: false,
			comingSoon: true,
			routeName: 'marine',
		},
	],
};
